import Vue from 'vue'
import App from './App.vue'
import 'vant/lib/index.css'
import router from './router'
import Router from 'vue-router'
import components from '@/components'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'


Vue.use(Router)
Vue.use(components)

Vue.prototype.$routeChange = (name) => {
  // window.$vrm.$$state.showNavPanel = false
  const vm = window.$vrm
  vm.$store.commit('setState', {key: 'showNavPanel', value: false})
  vm.$router.replace({name})
  document.documentElement.scrollTop = 0
}

Vue.config.productionTip = false

window.$vrm = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
